import { render, staticRenderFns } from "./widget-team.vue?vue&type=template&id=202ce586&scoped=true"
import script from "./widget-team.vue?vue&type=script&lang=ts"
export * from "./widget-team.vue?vue&type=script&lang=ts"
import style0 from "./widget-team.vue?vue&type=style&index=0&id=202ce586&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ce586",
  null
  
)

export default component.exports